import { Box } from "@mui/material"
import React, { useMemo, useState, useEffect, useRef } from "react"
import Modal from "react-bootstrap/Modal"
import Row from "react-bootstrap/esm/Row"
import Col from "react-bootstrap/Col"
import { Button as MuiButton } from "@mui/material"
import Button from "../../components/Button"
import SurveyComponent from "../RMO/components/cancerTemplate/Template"
import defaultSurveyConfig from "../RMO/components/cancerTemplateForm/template"
import "./MdRaiseRequest.scss"
import { useSelector } from "react-redux"
import Toast from "../../components/Toast"
import { getPatientDocumentsList, getRasiedRequestsById, raiseFileRequisitionRequest, renewFileRequisitionRequest } from "../../core/services/api/mrdService"
import { getPatientDetailMRD, getPatientInformation } from "../../core/services/api"
import { useTable, useSortBy, useGlobalFilter } from "react-table"
import { GlobalFilter } from "../frontDesk/patientDirectory/GlobalFilter"
import { COLUMNS } from "./MrdRaiseRequestColumns"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFileAlt,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons"
import { getTemplatesByType } from "core/services/api/patientDiagnosisService"
import moment from "moment"
import fileUtils from "fileUtils"
import { calculateAge } from "core/utils/date"

export default function MrdRaiseRequest() {
  const columns = useMemo(() => COLUMNS, [])
  const componentRef = useRef()
  const [data, setData] = useState<any>([])
  const [surveyData, setSurveyData] = useState<any>({})
  const [raiseRequestJson, setRaiseRequestJson] = useState<any>({})
  // const [requests, setRequests] = useState<any>([])
  const [show, setShow] = useState<boolean>(false)
  const [selectedPatient, setSelectedPatient] = useState<any>("")
  const [patientIds, setPatientIds] = useState<any>([])
  const [requestsRaised, setRequestsRasied] = useState<any>([])
  const [patientInfo, setPatientInfo] = useState<any>({})
  const [selectedRowId, setSelectedRowId] = useState<any>("")
  const [viewRowId, setViewRowId] = useState<any>("")

  //Toast 
  const [isSuccessful, setIsSuccessful] = useState<boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<any>("")
  const [renewSuccess, setRenewSuccess] = useState<boolean>(false)
  const [renewfailed, setRenewFailed] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [displayToast, setDisplayToast] = useState<any>(false)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },

    useGlobalFilter,
    useSortBy
  )
  const { globalFilter } = state

  useEffect(() => {
    let tempJson: any = {}
    getTemplatesByType("COMMON")
      .then((res: any) => {
        tempJson = res?.find((e: any) => e?.subType === "Requisition Form For File Reference")?.data[0]?.json || {}
        setRaiseRequestJson(tempJson)
      })
      .catch((err: any) => console.log(err?.message))
  }, [])

  useEffect(() => {
    const searchBtn: any = document.getElementById("fetchPatientDetailsBtn")
    if (searchBtn) {
      searchBtn.addEventListener("click", handleSearchClick)
    }

    return () => {
      if (searchBtn) {
        searchBtn.removeEventListener("click", handleSearchClick)
      }
    }
  }, [show, selectedPatient])

  useEffect(() => {
    if (show) {
      const tempData = { ...surveyData }
      tempData["dateOfApplication"] = moment().format("YYYY-MM-DD")
      tempData["applicantDateTime"] = moment().format("YYYY-MM-DDTHH:MM")
      setSurveyData(tempData)
    }
  }, [show])

  useEffect(() => {
    //Get API for requests raised  
    getRasiedRequestsById(userDetail?.id)
      .then((res: any) => {
        setRequestsRasied(res)
        setData(res)
      })
      .catch((err: any) => {
        console.log(err.message)
      })
  }, [show])

  useEffect(() => {
    if (selectedRowId) {
      getPatientDetailMRD(selectedRowId, viewRowId)
        .then((res: any) => {
          setPatientInfo(res)
        })
        .catch((err: any) => { setIsError(true); setErrorMessage(err?.response?.data?.message) })
    }
  }, [selectedRowId])

  const handleSearchClick = () => {
    fetchPatientDetails()
  }

  const upadatePatient = (data: any, id: any) => {
    setSurveyData({ ...surveyData, ...data })
    setSelectedPatient(id)
  }

  function fetchPatientDetails() {
    if (selectedPatient) {
      // setIsLoading(true)
      if (selectedPatient?.length <= 5) {
        setIsLoading(false)
        setDisplayToast({
          text: "Please enter the complete MOC ID",
          type: "error"
        })
      } else {
        getPatientInformation(selectedPatient)
          .then((res: any) => {
            const { data }: any = res
            setIsLoading(false)
            if (data?.length === 1) {
              const patId = data[0]
              //API call for specific file request options
              if (patId?.id) {
                const tempData = { ...surveyData }
                tempData["raiseRequestPatientName"] = patId?.name
                tempData["patName"] = patId?.name
                tempData["patId"] = selectedPatient
                tempData["dateOfApplication"] = moment().format("YYYY-MM-DD")
                tempData["applicantDateTime"] = moment().format("YYYY-MM-DDTHH:MM")
                setSurveyData(tempData)
                getPatientDocumentsList(patId?.id)
                  .then((res: any) => {
                    const temp = res.map((ele: any) => {
                      return { text: ele, value: ele }
                    })
                    const tempJsonObj = { ...raiseRequestJson }
                    tempJsonObj.pages[0].elements[13].choices = temp
                    setRaiseRequestJson({})
                    setRaiseRequestJson(tempJsonObj)
                  })
                  .catch((err: any) => {
                    console.log(err?.message)
                  })
              }
              setPatientIds(patId)
            } else if (data?.length > 0) {
              const filtered = data?.filter((ele: any) => ele?.mocId === selectedPatient)
              if (filtered?.length === 1) {
                const patId = filtered[0]
                //API call for specific file request options
                if (patId?.id) {
                  const tempData = { ...surveyData }
                  tempData["raiseRequestPatientName"] = patId?.name
                  tempData["patName"] = patId?.name
                  tempData["patId"] = selectedPatient
                  tempData["dateOfApplication"] = moment().format("YYYY-MM-DD")
                  tempData["applicantDateTime"] = moment().format("YYYY-MM-DDTHH:MM")
                  setSurveyData(tempData)
                  getPatientDocumentsList(patId?.id)
                    .then((res: any) => {
                      const temp = res.map((ele: any) => {
                        return { text: ele, value: ele }
                      })
                      const tempJsonObj = { ...raiseRequestJson }
                      tempJsonObj.pages[0].elements[13].choices = temp
                      setRaiseRequestJson({})
                      setRaiseRequestJson(tempJsonObj)
                    })
                    .catch((err: any) => {
                      console.log(err?.message)
                    })
                }
                setPatientIds(patId)
              } else {
                setDisplayToast({
                  text: "Please enter the complete MOC ID",
                  type: "error"
                })
              }
            } else if (data?.length === 0) {
              setDisplayToast({
                text: "Please enter the correct MOC ID",
                type: "error"
              })
            }
          })
          .catch((err: any) => {
            console.log(err?.message)
            setIsLoading(false)
            setDisplayToast({
              text: "Please enter the correct/complete MOC ID",
              type: "error"
            })
          })
      }
    }
  }

  const handleClose = () => {
    setShow(false)
    setSurveyData({})
  }

  const handleDocsClose = () => {
    setSelectedRowId("")
    setPatientInfo({})
  }

  const handleFormComplete = (dataObj: any) => {
    //API Integration for raise request
    const json = { ...raiseRequestJson }
    setRaiseRequestJson({})
    const element = document.getElementById("heading-test")
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
    // setIsLoading(true)

    const patId = patientIds
    const payload: any = {
      patientId: patId?.id,
      centerName: patId?.centers[0]?.centerName,
      accessorId: userDetail?.id,
      formData: dataObj,
      isAccessAll: dataObj?.AccessTo[0] === "Complete MR File" ? true : false,
    }
    if (dataObj?.AccessTo[0] === "Specify If Any") {
      payload["documentNames"] = dataObj?.specificFiles
    }
    raiseFileRequisitionRequest(payload)
      .then((res: any) => {
        setIsLoading(false)
        handleClose()
        setRaiseRequestJson(json)
        setSurveyData({})
        setIsSuccessful(true)
      })
      .catch((err: any) => {
        console.log(err?.message)
        setRaiseRequestJson(json)
        setIsLoading(false)
        setIsError(true)
      })
  }

  const handleRenewRequest = (index: any) => {
    const id = requestsRaised[index]?.id
    //API integration for renew request
    renewFileRequisitionRequest(id)
      .then((res: any) => {
        setRenewSuccess(true)
      })
      .catch((err: any) => {
        console.log(err.message, "ERROR")
        setRenewFailed(true)
      })
  }

  function downloadFiles() {
    var delay = 1000;
    const urls = patientInfo?.documents?.length > 0 ? patientInfo?.documents : []
    async function download(index: any) {
      if (index >= urls.length) {
        return;
      }
      var link = document.createElement('a');
      const documentUrl: any = await fileUtils.getFileUrl(urls[index]?.blobUrl)
      link.href = documentUrl
      link.download = '';
      setTimeout(function () {
        link.click();
        link.remove();
        download(index + 1);
      }, delay);
      document.body.appendChild(link);
    }
    download(0);
  }

  return (
    <div className="mrdRaiseRequestContainer">
      {
        isSuccessful ? (
          <Toast
            textMessage="Request raised successfully"
            type="success"
            onCloseText={"Close"}
            onClose={() => setIsSuccessful(false)}
          ></Toast>
        ) : renewSuccess ? (
          <Toast
            textMessage="Request renewed successfully"
            type="success"
            onCloseText={"Close"}
            onClose={() => setRenewSuccess(false)}
          ></Toast>
        ) : renewfailed ? (
          <Toast
            textMessage="Mrd request is not approved yet"
            type="error"
            onCloseText={"Close"}
            onClose={() => setRenewFailed(false)}
          ></Toast>
        ) : isError ? (
          <Toast
            textMessage={errorMessage?.length > 0 ? errorMessage : "Something went wrong, please try again later."}
            type="error"
            onCloseText={"Close"}
            onClose={() => { setIsError(false); setErrorMessage(""); handleDocsClose(); }}
          ></Toast>
        ) : ("")
      }
      <div className="manage-patients-container">
        <div className="manage-patients-container">
          <div className="row add-new">
            <div className="col-9"></div>
            <div className="col-3 add-new-text">
              <MuiButton
                className="button-container"
                onClick={() => setShow(true)}
              >
                Raise New Request
              </MuiButton>
            </div>
            <div className="search-container">
              <div>
                <GlobalFilter
                  filter={globalFilter}
                  setFilter={setGlobalFilter}
                />
              </div>
              <div>
                {/* <Dropdown placeholder="All" selected="" option=""></Dropdown> */}
              </div>
            </div>
            <div>
              <table
                {...getTableProps()}
                // @ts-ignore
                ref={componentRef}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps()}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              paddingLeft: "10px",
                            }}
                          >
                            {column.render("Header")}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody
                  className="border-radiusImportant"
                  {...getTableBodyProps()}
                >
                  {rows.map((row: any) => {
                    prepareRow(row)
                    return (
                      <tr {...row.getRowProps()} style={{ cursor: "pointer" }}>
                        {row.cells.map((cell: any) => {
                          return (
                            <td
                              onClick={() => {
                                if (
                                  cell?.column?.id?.toLowerCase() === "edit"
                                ) {
                                  handleRenewRequest(row?.id)
                                } else if (cell?.column?.id?.toLowerCase() === "view") {
                                  setViewRowId(row?.original?.id ? row?.original?.id : "")
                                  setSelectedRowId(row?.original?.patientId ? row?.original?.patientId : "")
                                }
                              }}
                              style={{
                                maxWidth: "200px",
                                width: "200px",
                                wordWrap: "break-word",
                                maxHeight: "100px",
                                paddingLeft: "10px",
                                verticalAlign: "left",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontSize: "18px",
                                lineHeight: "24px",
                                letterSpacing: "1.35px",
                                textAlign: "initial",
                              }}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
                <tfoot>
                  {footerGroups.map((footerGroup) => (
                    <tr {...footerGroup.getFooterGroupProps()}>
                      {footerGroup.headers.map((column) => (
                        <td {...column.getFooterProps()}>
                          {column.render("Footer")}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      {
        show ? (
          <Modal size="xl" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>
                <Row className="heading-test" style={{ paddingLeft: "25px" }}>
                  File Requisition Request
                </Row>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {
                isLoading ? (
                  <div
                    style={{
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 9999,
                    }}
                  >
                    <div
                      style={{ width: "3rem", height: "3rem" }}
                      className="spinner-border text-primary"
                    ></div>
                  </div>
                ) : displayToast ? (
                  <Toast
                    textMessage={displayToast?.text}
                    type={displayToast?.type}
                    onCloseText={"Close"}
                    onClose={() => setDisplayToast(false)}
                  ></Toast>
                ) : null
              }
              <Box className="mrd-raise-request-content">
                <div style={{ paddingLeft: "10px" }}>
                  <label htmlFor="" className="label">
                    <b>
                      CCPL/MRD/042020/V00/F027
                    </b>
                  </label>
                </div>
                <SurveyComponent
                  css={defaultSurveyConfig.defaultSurveyCSS}
                  data={surveyData}
                  json={raiseRequestJson}
                  onComplete={(survey: any) => {
                    console.log(survey.data)

                    /** Save to a database */
                    /** Add to a spreadsheet, etc.... */
                    handleFormComplete(survey?.data)
                  }}
                  updateCallback={upadatePatient}
                  hideDot={true}
                />
              </Box>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
          </Modal >
        ) : ("")
      }
      {
        selectedRowId?.length > 0 ? (
          <Modal size="xl" show={selectedRowId} onHide={handleDocsClose}>
            <Modal.Header closeButton>
              <Modal.Title>
                <Row className="heading-test" style={{ paddingLeft: "25px" }}>
                  <Col className="basic-patient-details">
                    {patientInfo?.isVIP ? patientInfo?.mocId : patientInfo?.name}-{patientInfo?.mocId}-{patientInfo?.gender}-{calculateAge(patientInfo?.dob)}
                  </Col>
                </Row>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Box className="mrd-raise-request-content">
                <div className="pedigree-container">
                  {
                    patientInfo?.documents?.length > 0 && (
                      <div className="d-flex justify-content-end mt-3">
                        <Button
                          disabled={patientInfo?.documents?.length > 0 ? false : true}
                          text="Download All" id="download-all"
                          onClick={(e: any) => downloadFiles()} />
                      </div>
                    )
                  }
                  <div className="pedigree-docs-container">
                    {patientInfo?.documents?.length > 0 ?
                      patientInfo?.documents?.map((ele: any) => {
                        return (
                          <div className="file-list">
                            <span>
                              <FontAwesomeIcon
                                className="doc-icon"
                                size="4x"
                                icon={faFileAlt}
                              />
                            </span>
                            <div className="file-name">{ele?.name}</div>
                            <a
                              // href={ele?.blobUrl}
                              // download={ele?.blobUrl}
                              onClick={() => fileUtils.downloadFile(ele)}
                            >
                              <FontAwesomeIcon
                                className="download-icon"
                                icon={faArrowDown}
                              />
                            </a>
                          </div>
                        )
                      }) : (
                        <div style={{ padding: "0 0 0 25px", fontSize: "15px" }}>No Documents Available</div>
                      )
                    }
                  </div>
                </div>
              </Box>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
          </Modal >
        ) : null
      }
    </div>
  )
}
